export * from './sgkd001a.service';
export * from './sgkd004a.service';
export * from './sgkd005a.service';
export * from './sgkd015a.service';
export * from './sgkd016a.service';
export * from './sgkd022a.service';
export * from './sgkd030a.service';
export * from './sgkd034a.service';
export * from './sgkd038a.service';
export * from './sgkd041a.service';
export * from './sgkd042a.service';
export * from './sgkd043a.service';
export * from './sgkd044a.service';
export * from './sgkd045a.service';
export * from './sgkd047a.service';
export * from './sgkd048a.service';
export * from './sgkd049a.service';
export * from './sgkd050a.service';
export * from './sgkd051a.service';
export * from './sgkd052a.service';

export * from './sZMD036A.service';
export * from './sZME037A.service';
export * from './sZME038A.service';
export * from './sZME042A.service';
export * from './sZME043A.service';
import { Sgkd001aService } from './sgkd001a.service';
import { Sgkd004aService } from './sgkd004a.service';
import { Sgkd005aService } from './sgkd005a.service';
import { Sgkd015aService } from './sgkd015a.service';
import { Sgkd016aService } from './sgkd016a.service';
import { Sgkd022aService } from './sgkd022a.service';
import { Sgkd030aService } from './sgkd030a.service';
import { Sgkd034aService } from './sgkd034a.service';
import { Sgkd038aService } from './sgkd038a.service';
import { Sgkd041aService } from './sgkd041a.service';
import { Sgkd042aService } from './sgkd042a.service';
import { Sgkd043aService } from './sgkd043a.service';
import { Sgkd044aService } from './sgkd044a.service';
import { Sgkd045aService } from './sgkd045a.service';
import { Sgkd047aService } from './sgkd047a.service';
import { Sgkd048aService } from './sgkd048a.service';
import { Sgkd049aService } from './sgkd049a.service';
import { Sgkd050aService } from './sgkd050a.service';
import { Sgkd051aService } from './sgkd051a.service';
import { Sgkd052aService } from './sgkd052a.service';

import { SZMD036AService } from './sZMD036A.service';
import { SZME037AService } from './sZME037A.service';
import { SZME038AService } from './sZME038A.service';
import { SZME042AService } from './sZME042A.service';
import { SZME043AService } from './sZME043A.service';
export const APIS_SGKD = [
  Sgkd001aService,
  Sgkd004aService,
  Sgkd005aService,
  Sgkd015aService,
  Sgkd016aService,
  Sgkd022aService,
  Sgkd030aService,
  Sgkd034aService,
  Sgkd038aService,
  Sgkd041aService,
  Sgkd042aService,
  Sgkd043aService,
  Sgkd044aService,
  Sgkd045aService,
  Sgkd047aService,
  Sgkd048aService,
  Sgkd049aService,
  Sgkd050aService,
  Sgkd051aService,
  Sgkd052aService,
  SZMD036AService,
  SZME037AService,
  SZME038AService,
  SZME042AService,
  SZME043AService
];
